<script setup>
const props=defineProps(['brand']);const failed=ref(false);watch(()=>props.brand?.image,()=>failed.value=false);
const valid=computed(()=>/^[a-f\d-]{36}$/i.test(props.brand?.image||''));
</script>
<template><div class="brand-logo"><img v-if="valid&&!failed" :src="`/files/uploaded/${brand.image}.webp`" :alt="`Логотип ${brand.title}`" width="80" height="80" @error="failed=true"><span v-else aria-hidden="true">{{brand?.title?.slice(0,1)}}</span></div></template>
